import { ErrorModal } from "@dexteel/mesf-core";
import { Grid2, Paper, Typography } from "@mui/material";
import { GridApi, RowClassParams, RowStyle } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { useGridDefinitions } from "@/controls/ag-grid/components/GridDefinitions";
import { CenteredLazyLoading } from "@/controls/LazyLoading";
import { routePartsManager } from "@/setup/routes/report.routes";
import { TextFieldSearchFilter } from "@/shared/components/TextFieldSearchFilter";
import { useTableData } from "../hooks/useTableData";
import { useParts } from "../PartsManagerPage";

export const partTypeCodes = [
	{ Code: "U", Name: "Universal Roll", Color: "#fdedec" },
	{ Code: "E", Name: "Edger Roll", Color: "#f5eef8" },
	{ Code: "H", Name: "Carrier", Color: "#eaf2f8" },
	{ Code: "C", Name: "Chock", Color: "#e8f8f5" },
	{ Code: "G", Name: "Guide", Color: "#e9f7ef" },
	{ Code: "A", Name: "Arbor", Color: "#fef9e7" },
	{ Code: "T", Name: "Cassette", Color: "#fef5e7" },
	{ Code: "K", Name: "Cassette Chock", Color: "#fbeee6" },
	{ Code: "D", Name: "Donut", Color: "#eaecee" },
];

export const TableParts = () => {
	const [filterValue, setFilterValue] = useState("");
	const [gridApi, setGridApi] = useState<GridApi | null>(null);
	const [error, setError] = useState("");
	const navigate = useNavigate();

	const { data, isLoading } = useParts({
		onError: (error) => setError(error.message),
	});

	const rows = data?.parts ?? [];

	const getRowStyle = (params: RowClassParams): RowStyle | undefined => {
		const type =
			partTypeCodes.find((type) => type.Code === params.data.PartTypeCode) ||
			null;
		return { background: type ? type?.Color : "" };
	};

	const { columnDefs } = useTableData();
	const { defaultColDef } = useGridDefinitions({});

	return (
		<>
			<Grid2 container justifyContent="center">
				<Grid2
					size={{ xs: 12, md: 12 }}
					style={{ padding: "0 15px", marginTop: 10 }}
				>
					<Typography variant="h5" style={{ fontWeight: 600 }}>
						Parts Manager
					</Typography>
				</Grid2>
				<Grid2 size={{ md: 12, xs: 12 }} style={{ margin: "10px 15px" }}>
					<Paper elevation={0}>
						<TextFieldSearchFilter
							value={filterValue}
							onChange={(val) => {
								setFilterValue(val);
								gridApi?.setGridOption("quickFilterText", val);
							}}
						/>
					</Paper>
				</Grid2>
				<Grid2 container style={{ padding: "0 15px" }}>
					<Grid2 size={{ xs: 12 }}>
						<Paper elevation={4} style={{ padding: 6 }}>
							<div style={{ height: "70vh", padding: 5 }}>
								<AgGridReact
									loading={isLoading}
									rowData={rows}
									columnDefs={columnDefs}
									defaultColDef={defaultColDef}
									rowHeight={34}
									headerHeight={34}
									animateRows
									suppressContextMenu
									onGridReady={(params) => setGridApi(params.api)}
									getRowStyle={getRowStyle}
									loadingOverlayComponent={CenteredLazyLoading}
									getRowId={(params) => String(params.data.PartId)}
									onRowDoubleClicked={(event) => {
										navigate(`${routePartsManager}/${event.data.PartId}`);
									}}
									gridOptions={{
										rowSelection: {
											mode: "singleRow",
											checkboxes: false,
											enableClickSelection: true,
										},
									}}
								/>
							</div>
						</Paper>
					</Grid2>
				</Grid2>
			</Grid2>
			<ErrorModal error={error} onHide={() => setError("")} />
		</>
	);
};
